import "../styles/global/index.scss"
import "../styles/progress.css"
import "../styles/fonts.css"

import React, { useEffect, useState } from "react"
import { ThemeProvider } from "../src/contexts/ThemeContext"
import { DarkModeProvider } from "../src/contexts/DarkModeContext"
import { WalletProvider } from "../src/contexts/WalletContext"
import { ModalProvider } from "../src/contexts/ModalContext"
import { ToastProvider } from "react-toast-notifications"
import { ChakraProvider } from "@chakra-ui/react"
import Script from "next/script"
import AdminCmsTheme from "../src/components/AdminCms/Layout/Theme"
import { Toaster } from "react-hot-toast"
import { useRouter } from "next/router"
// import { SessionProvider } from "next-auth/react" // Removed to avoid 404 errors for /api/auth/session
import { SystemProvider } from "../src/contexts/SystemContext"
import { AuthProvider } from "../src/contexts/AuthProvider"
import ComingSoonWall from "../src/components/ComingSoonWall"
import { COMING_SOON } from "../utils/enum/constants"

// @ts-ignore
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
// @ts-ignore
// import { WagmiProvider } from 'wagmi';



const { NEXT_PUBLIC_GOOGLE_ANALYTICS } = process.env
function MyApp({ Component, pageProps }) {
	const getLayout = Component.getLayout || ((page) => page)

	const router = useRouter()
	// Check if the current route starts with /cms
	const isCMSRoute = router.asPath.startsWith("/cms")
	// A client created in the function body is replaced on every route update,
	// including the shallow ?hape= open. Query observers keep the first client
	// and the wardrobe then writes the outfit into the new one, so the preview
	// keeps posting the native traits it fetched at open.
	const [queryClient] = useState(() => new QueryClient())

	// Apply a CSS class to the body depending on the current route
	useEffect(() => {
		document.body.className = isCMSRoute ? "cms-body" : ""
	}, [router.asPath]) // Rerun this effect every time the route changes

	if (COMING_SOON && !isCMSRoute) {
		return <ComingSoonWall />
	}

	return getLayout(
		<>
			<Script
				strategy="lazyOnload"
				src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS}`}
			/>

			<Script id="loadGoogle" strategy="lazyOnload">
				{`
		window.dataLayer = window.dataLayer || [];
		function gtag(){dataLayer.push(arguments);}
		gtag('js', new Date());
		gtag('config', '${NEXT_PUBLIC_GOOGLE_ANALYTICS}', {
		page_path: window.location.pathname,
		});
	`}
			</Script>
			<QueryClientProvider client={queryClient}>
				{/* SessionProvider removed to avoid 404 errors for /api/auth/session */}
				<AuthProvider>
					<SystemProvider>
						<ModalProvider>
							<DarkModeProvider>
								<ThemeProvider>
									<Toaster
										position="top-center"
										containerStyle={{ zIndex: 100000 }}
									/>
									<ToastProvider 
										autoDismiss={true} 
										autoDismissTimeout={4000}
										placement="bottom-center"
									>
										<style jsx global>{`
											.react-toast-notifications__container {
												z-index: 9999 !important;
											}
										`}</style>
										<ChakraProvider theme={AdminCmsTheme}>
											{/* <WagmiProvider config={config}> */}
														<WalletProvider>
															<Component {...pageProps} />
														</WalletProvider>
											{/* </WagmiProvider> */}
										</ChakraProvider>
									</ToastProvider>
								</ThemeProvider>
							</DarkModeProvider>
						</ModalProvider>
					</SystemProvider>
				</AuthProvider>
				<ReactQueryDevtools initialIsOpen={false} />
			</QueryClientProvider>
		</>,
	)
}

export default MyApp
